const darkMode = {
    name: "Dark Mode",
    path: "dark-mode",
    title: "Dark Mode",
    description: "Using variants to style your site in dark mode.",
    heading: false,
    exampleData: [
        {
            "title": "",
            "description": "",
            "moreDescription": "",
            "parentClass": "!bg-none !border-0",
            "example": {
                "element": "div",
                "className": "relative",
                "code": `<div class="bg-color-white dark:bg-color-gray-800 rounded-lg px-6 py-8 ring shadow-xl ring-color-gray-900/5">
  <div>
    <span class="inline-flex items-center justify-center rounded-md bg-color-indigo-500 p-2 shadow-lg">
      <svg class="h-6 w-6 stroke-color-white" ...>
        <!-- ... -->
      </svg>
    </span>
  </div>
  <h3 class="text-color-gray-900 dark:text-color-white mt-5 text-base font-medium tracking-tight ">Writes upside-down</h3>
  <p class="text-color-gray-500 dark:text-color-gray-400 mt-2 text-sm ">
    The Zero Gravity Pen can be used to write in any orientation, including upside-down. It even works in outer space.
  </p>
</div>`
            }
        },
        {
            "title": "",
            "description": "",
            "moreDescription": "",
            "parentClass": "!bg-none !border-0",
            "example": {
                "element": "div",
                "className": "relative",
                "code": `<html class="dark" [data-theme="system"]>
  <body>
    <div class="bg-color-white dark:bg-color-black">
      <!-- ... -->
    </div>
  </body>
</html>`
            }
        }
    ],
    htmlData:[
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Now that dark mode is a first-class feature of many operating systems, it's becoming more and more common to design a dark version of your website to go along with the default design.
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                To make this as easy as possible, Unicss includes a <dark> variant that lets you style your site differently when dark mode is enabled:
            </p>
            <div class="grid grid-columns-1 sm:grid-columns-2 border border-color-gray-200 dark:border-color-gray-700 rounded-lg">
              <div class="p-8 pt-7">
                  <p class="mb-2 text-sm font-medium text-color-gray-500">Light mode</p>
                  <div class="rounded-lg bg-color-white px-6 py-8 shadow-xl ring ring-color-gray-900/5">
                    <div>
                        <span class="inline-flex items-center justify-center rounded-md bg-color-indigo-500 p-2 shadow-lg">
                          <svg class="h-6 w-6 text-color-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                          </svg>
                        </span>
                    </div>
                    <p class="mt-5 text-base font-medium tracking-tight text-color-gray-900">Writes upside-down</p>
                    <p class="mt-2 text-sm text-color-gray-500">The Zero Gravity Pen can be used to write in any orientation,
                        including upside-down. It even works in outer space.
                    </p>
                  </div>
              </div>
              <div class="bg-color-gray-900 p-8 pt-7">
                  <p class="mb-2 text-sm font-medium text-color-gray-400">Dark mode</p>
                  <div class="rounded-lg bg-color-gray-800 px-6 py-8 shadow-xl ring ring-color-gray-900/5">
                    <div>
                        <span class="inline-flex items-center justify-center rounded-md bg-color-indigo-500 p-2 shadow-lg">
                          <svg class="h-6 w-6 text-color-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                          </svg>
                        </span>
                    </div>
                    <p class="mt-5 text-base font-medium tracking-tight text-color-white">Writes upside-down</p>
                    <p class="mt-2 text-sm text-color-gray-400">The Zero Gravity Pen can be used to write in any orientation,
                        including upside-down. It even works in outer space.
                    </p>
                  </div>
              </div>
            </div>
            
            `
        },
        {
            data: `
            <p class="text-color-gray-800 font-semibold text-sm dark:text-color-gray-100 mb-6">
                Toggling dark mode
            </p>
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
                When the dark or light class is toggled on the 'html' element, Unicss switches between dark and light modes accordingly. Or [data-theme="system"] can be used to follow the system preference.
            </p>
            
            `
        },
    ]
};

export default darkMode;


<div class="grid grid-columns-1 sm:grid-columns-2 sr-only">
              <div class="p-8 pt-7">
                  <p class="mb-2 text-sm font-medium text-color-gray-500">Light mode</p>
                  <div class="rounded-lg bg-color-white px-6 py-8 shadow-xl ring ring-color-gray-900/5">
                    <div>
                        <span class="inline-flex items-center justify-center rounded-md bg-color-indigo-500 p-2 shadow-lg">
                          <svg class="h-6 w-6 text-color-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                          </svg>
                        </span>
                    </div>
                    <p class="mt-5 text-base font-medium tracking-tight text-color-gray-900">Writes upside-down</p>
                    <p class="mt-2 text-sm text-color-gray-500">The Zero Gravity Pen can be used to write in any orientation,
                        including upside-down. It even works in outer space.
                    </p>
                  </div>
              </div>
              <div class="bg-color-gray-900 p-8 pt-7">
                  <p class="mb-2 text-sm font-medium text-color-gray-400">Dark mode</p>
                  <div class="rounded-lg bg-color-gray-800 px-6 py-8 shadow-xl ring ring-color-gray-900/5">
                    <div>
                        <span class="inline-flex items-center justify-center rounded-md bg-color-indigo-500 p-2 shadow-lg">
                          <svg class="h-6 w-6 text-color-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                          </svg>
                        </span>
                    </div>
                    <p class="mt-5 text-base font-medium tracking-tight text-color-white">Writes upside-down</p>
                    <p class="mt-2 text-sm text-color-gray-400">The Zero Gravity Pen can be used to write in any orientation,
                        including upside-down. It even works in outer space.
                    </p>
                  </div>
              </div>
            </div>
